import { render, staticRenderFns } from "./ChartPie.vue?vue&type=template&id=692671c0&"
import script from "./ChartPie.vue?vue&type=script&lang=ts&"
export * from "./ChartPie.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports